import styled, { css } from 'styled-components'

import { IconProps } from './type'

export const StyledFigure = styled.figure<Partial<IconProps>>`
  object-fit: contain;

  ${({ theme, icSize = 'small' }) => css`
    width: ${icSize === 'auto' ? '100%' : `${theme.icon.sizes[icSize]}px`};
    height: ${icSize === 'auto' ? '100%' : `${theme.icon.sizes[icSize]}px`};
  `}

  ${({ theme, icColor, hexColorCode }) =>
    (icColor || hexColorCode) &&
    css`
      color: ${icColor ? theme.colors[icColor] : hexColorCode};
    `}

  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  flex: 0 0 auto;

  ${({ disabled }) =>
    disabled &&
    css`
      outline: dotted 2px #006bff;
      border-radius: 4px;
      cursor: not-allowed;
    `}

  ${({ nonFocusable }) =>
    nonFocusable &&
    css`
      outline: solid 2px #006bff;
    `}

  &:focus, &:hover {
    outline: 3px solid #abbed1;
    border-radius: 4px;
  }

  svg {
    width: 100%;
    height: 100%;
  }
`
